/**
 * StickerListRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { StickerData } from './sticker_data'

/**
 * StickerListRes
 */
export interface StickerListRes {
  /** 数据列表 */
  items?: StickerData[]
  /** 总数 */
  total?: number
  /** 当前页 */
  page?: number
  /** 每页数量 */
  page_size?: number
}

/**
 * StickerListRes Schema
 */
export const StickerListResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '数据列表',
      format: '[]*model.StickerData',
      items: { $ref: 'StickerData', description: '' },
      type: 'array',
      label: '数据列表',
    },
    total: {
      description: '总数',
      format: 'int',
      type: 'integer',
      label: '总数',
    },
    page: {
      description: '当前页',
      format: 'int',
      type: 'integer',
      label: '当前页',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
  },
  type: 'object',
}
